//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
let d=[[[0,"Delay",1,0],[0,"FaceAnalysisViewsType",1,0],[0,"HighlightHiddenEdgesToggle",1,0],[0,"HighlightOriginalToggle",1,0],[0,"HighlightSelectionOnRolloverToggle",1,0],[0,"HighlightWithThickWidthToggle",1,0],[0,"MethodType",1,0],[0,"MouseGestureType",1,0],[0,"QuickPickLockDialogPosition",1,0],[0,"QuickPickOnDelayToggle",1,0],[0,"QuickPickSeeThruToggle",1,0],[0,"RolloverDelay",1,0],[0,"SelectionRadiusType",1,0],[0,"SelectionRuleType",1,0],[0,"ShadedViewsType",1,0],[0,"ShowCrosshairsToggle",1,0],[0,"TangencyTolerance",1,0],[0,"Tolerance",1,0],[0,"TooltipOnRolloverToggle",1,0]],[],[]];
SPLM.Display.SelPref = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.SelPref";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.SelPref.MouseGesture = Object.freeze({
    "Lasso" : "Lasso", "Rectangle" : "Rectangle", "Circle" : "Circle"});

SPLM.Display.SelPref.SelectionRule = Object.freeze({
    "Inside" : "Inside", "Outside" : "Outside", "Crossing" : "Crossing", "InsideCrossing" : "InsideCrossing", "OutsideCrossing" : "OutsideCrossing"});

SPLM.Display.SelPref.ShadedViews = Object.freeze({
    "HighlightEdges" : "HighlightEdges", "HighlightFaces" : "HighlightFaces"});

SPLM.Display.SelPref.FaceAnalysisViews = Object.freeze({
    "HighlightEdges" : "HighlightEdges", "HighlightFaces" : "HighlightFaces"});

SPLM.Display.SelPref.SelectionRadius = Object.freeze({
    "Medium" : "Medium", "Small" : "Small", "Large" : "Large"});

SPLM.Display.SelPref.Method = Object.freeze({
    "Simple" : "Simple", "Wcs" : "Wcs", "WcsLeft" : "WcsLeft", "WcsRight" : "WcsRight"});

export default SPLM;